var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ShippingHeaderAdd',{attrs:{"title":_vm.id ? _vm.$t('atualizar-integracao') : _vm.$t('adicionar-nova-integracao')},on:{"back":_vm.back}}),_c('ShippingIntegrationAddForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }